interface BadgeProps {
  label: string;
  variant: 'ok' | 'error' | 'warn' | 'info' | string;
}

const VARIANT_CLASS: Record<string, string> = {
  ok: 'badge-ok',
  error: 'badge-error',
  warn: 'badge-warn',
  info: 'badge-info',
};

export function Badge({ label, variant }: BadgeProps) {
  const cls = VARIANT_CLASS[variant] ?? `badge-${variant}`;
  return <span class={`badge ${cls}`}>{label}</span>;
}
